import _get from 'lodash/get';
export const QA = 'QA';
export const PROD = 'PROD';
export const getEnvironment = () => {
  const hostname = _get(window, 'location.hostname', '');
  if (hostname.match(/www\..*\.com/)) {
    return PROD;
  }
  return QA;
};
export const isQA = () => getEnvironment() === QA;
export default getEnvironment;